import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";

import classes from "./Dropdown.module.scss";
import arrow from "./../../../../assets/icons/box_arrow.png";
import DropdownItem from "./DropdownItem/DropdownItem";
import * as actionTypes from "../../../../store/actions/actionTypes";

class Dropdown extends Component {

  dropdownSelect = (campaign_id) => {
    this.props.changeCampaign(campaign_id);
  };

  render() {
    if (!_.isEmpty(this.props.campaigns)) {
      // get selected campaign index
      let selected = this.props.selected;
      // generate other campaign list
      let last = Object.keys(this.props.campaigns).length - 1;
      let index = 0;
      let campaigns = [];
      for (const [key, campaign] of Object.entries(this.props.campaigns)) {
        campaigns.push(
          <DropdownItem key={key} click={() => this.dropdownSelect(key)} last={index === last}>
            {campaign.name}
          </DropdownItem>
        );
        index++;
      }
      selected = selected > 0 ? this.props.campaigns[selected].name : "";

      let dropdownMenu = null,
        style = null,
        iconStyle = null;
      if (this.props.show) {
        dropdownMenu = <div className={classes.dropdownMenu}>{campaigns}</div>;
        style = {
          borderBottomLeftRadius: "0px",
          borderBottomRightRadius: "0px",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
        };
        iconStyle = {
          transform: "rotate(180deg)"
        };
      }
      let icon =
        campaigns.length > 1 ? <img className={classes.arrow} src={arrow} alt="Dropdown Arrow" style={iconStyle} /> : null;

      return (
        <div className={classes.dropdown} style={style}>
          <div className={classes.selected} onClick={campaigns.length > 1 ? this.props.toggleShow : null}>
            {selected}
            {icon}
          </div>
          {dropdownMenu}
        </div>
      );
    } else {
      return null;
    }
  }
}

export default (Dropdown);
